import React from "react";
import styled from "styled-components";

export default function BlogBox({ title, text, index }) {
  return (
    <Card>
      <Top><span>{String(index).padStart(2, "0")}</span><i /></Top>
      <h3>{title}</h3>
      <p>{text}</p>
    </Card>
  );
}

const Card = styled.article`
  height: 100%; padding: 32px; border: 1px solid rgba(255,255,255,.12); border-radius: 24px; background: rgba(255,255,255,.06); transition: .25s ease;
  &:hover { background: rgba(255,255,255,.1); transform: translateY(-4px); }
  h3 { margin-top: 34px; color: #fff; font-size: 1.35rem; letter-spacing: -.025em; }
  > p { margin-top: 15px; color: rgba(255,255,255,.64); font-size: .83rem; line-height: 1.82; }
`;
const Top = styled.div`display: flex; align-items: center; gap: 12px; span { color: #a8cf45; font-size: .68rem; font-weight: 800; } i { height: 1px; flex: 1; background: rgba(255,255,255,.12); }`;
